<template>
	<dms-wrapper :label="labelText" v-bind="{wrapp, validationRules, span, ...$attrs}" :validation-property="validationPropertyCmp" :disabled="isDisabled">
		<el-switch v-model="value" class="frm-switch" :disabled="isDisabled" :active-text="activeText" :inactive-text="inactiveText" :active-color="activeColor"
			:inactive-color="inactiveColor" />
	</dms-wrapper>
</template>

<script>
import { BaseInput } from '#components/dms/common/baseInput';
import DmsWrapper from '#components/dms/form/Wrapper.vue';

export default BaseInput.extend({
	name: 'DmsSwitch',
	components: { DmsWrapper },
	props: {
		active: String,
		inactive: String,
		activeKey: String,
		inactiveKey: String,
		activeColor: String,
		inactiveColor: String,
	},
	computed: {
		activeText() {
			return this.getText(this.active, this.activeKey);
		},
		inactiveText() {
			return this.getText(this.inactive, this.inactiveKey);
		},
	},
});
</script>

<style lang="scss" scoped>
	.frm-switch {
		min-height: 28px;
		align-items: center;
	}
</style>
